const MAX_WIDTH = 2000;

/**
 * Turns a pasted or dropped image into a data URL the API accepts (PNG or JPEG), scaled down to
 * at most 2000 px wide so a 5K screenshot does not become a 20 MB upload.
 */
export async function imageFileToDataUrl(file: Blob): Promise<string> {
  const bitmap = await createImageBitmap(file);
  const scale = Math.min(1, MAX_WIDTH / bitmap.width);
  const canvas = document.createElement('canvas');
  canvas.width = Math.round(bitmap.width * scale);
  canvas.height = Math.round(bitmap.height * scale);
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas 2D context unavailable');
  ctx.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
  bitmap.close();
  // Photos compress far better as JPEG; screenshots stay sharp as PNG.
  return file.type === 'image/png' && file.size < 3_000_000
    ? canvas.toDataURL('image/png')
    : canvas.toDataURL('image/jpeg', 0.86);
}

export function imageFromTransfer(data: DataTransfer | null): File | null {
  if (!data) return null;
  for (const item of Array.from(data.items ?? [])) {
    if (item.kind === 'file' && item.type.startsWith('image/')) return item.getAsFile();
  }
  return Array.from(data.files ?? []).find((f) => f.type.startsWith('image/')) ?? null;
}
